/**
 * Centralized analytics configuration.
 *
 * Production-only gating strategy (belt-and-suspenders, per requirement
 * "Load only in production. Do not initialize on localhost or development
 * environments."):
 *
 *   1. `process.env.NODE_ENV === "production"` — true only for a real
 *      `craco build` (production bundle). The Preview environment runs
 *      `craco start` (webpack-dev-server), which is always "development".
 *   2. A hostname denylist — extra safety net so analytics never fires
 *      on localhost or on any *.preview.emergentagent.com Preview URL,
 *      even in the hypothetical case a preview were ever served from a
 *      production-mode build.
 *
 * GA4's Measurement ID and Clarity's Project ID are PUBLIC client-side
 * identifiers (they cannot authenticate access to your GA4/Clarity admin
 * accounts), so they're safe to hardcode here rather than as
 * `REACT_APP_*` env vars — this project has a single shared `.env` for
 * both Preview and Production builds, so an env-var toggle would apply
 * identically to both anyway. The actual production/dev gating happens
 * via `isProduction` below, not via which IDs are present.
 */
const NON_PRODUCTION_HOSTNAME_PATTERN = /^(localhost|127\.0\.0\.1|0\.0\.0\.0)$|\.preview\.emergentagent\.com$/i;

function detectIsProduction() {
  if (process.env.NODE_ENV !== "production") return false;
  if (typeof window === "undefined") return false;
  return !NON_PRODUCTION_HOSTNAME_PATTERN.test(window.location.hostname);
}

export const analyticsConfig = {
  isProduction: detectIsProduction(),
  ga4MeasurementId: "G-7XFVFP5CJ2",
  clarityProjectId: "xw3dfgtbh9",
};
